<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">新建仓库</div>
      </div>
    </div>

    <el-form :model="formData" ref="form" :rules="rules" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item
            :prop="formData.bizCode"
            required
            label='仓库编码'
          >
            <el-input v-model="formData.bizCode" placeholder="请设置仓库编码" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item
            :prop="formData.name"
            required
            label='仓库名称'
          >
            <el-input v-model="formData.name" placeholder="请设置仓库名称" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item
            :prop="formData.inventoryManager"
            label="仓库管理员"
            required
          >
            <el-input v-model="formData.inventoryManager" placeholder="请设置仓库管理员"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
//saveWarehouseDetailsAPI
import { saveWarehouseAPI } from '@/api/system/warehousemanagement'
export default {
  components: {},
  data() {
    return {
      formData: {
        name: '',
        bizCode:'',
        inventoryManager: '',
      },
      rules: {
        name: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
        bizCode: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
        inventoryManager: [{ required: true, message: '请输入', trigger: ['blur', 'change'] }],
      },
      clickFlag: false,
    }
  },
  created() {
    // this.reset()
    // this.formData.parentFullCodeList = ['440000', '440100', '440103']
  },

  methods: {
    reset() {
      this.formData = {
        name: '',
        bizCode: '',
        inventoryManager: '',
      }
      this.resetForm('form')
    },
    
    submit(callback) {
      if (this.clickFlag) {
        return
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.clickFlag = true
          saveWarehouseAPI(this.formData)
            .then((res) => {
              this.clickFlag = false
              if (res.flag) {
                this.reset()
                callback(true)
              } else {
                this.$message.error(res.message)
              }
            })
            .catch((error) => {
              this.clickFlag = false
              console.log(error)
            })
        }
      })
    },
  },
}
</script>

<style scoped lang='less'>
@import './form.less';

::v-deep {
  .el-form-item.preview {
    margin-bottom: 0;
  }
  .no-contract-type {
    padding: 30px;
    background-color: #f8f8f8;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #dde4ff;
    margin-bottom: 20px;
  }
}
/deep/ .flex {
  .el-input--suffix .el-input__inner {
    width: 145px;
  }
}
/deep/.area-select-wrap .area-select {
  margin-left: 0px;
  // margin-right: 10px;
}
// .area-select.medium

/deep/ .area-select.medium {
  width: 146px;
  height: 39px;
}
/deep/ .area-select-wrap {
  display: flex;
}
/deep/ .area-select .area-selected-trigger {
  padding: 0 0 0 10px;
}
.flex {
  display: flex;
}
.area-select {
  height: 38px;
}
</style>